import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-076cc143"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-bs-target"]
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "card-body overflow-scroll" }
const _hoisted_4 = { class: "card-text fw-bold" }
const _hoisted_5 = ["id"]
const _hoisted_6 = { class: "modal-dialog modal-xl" }
const _hoisted_7 = { class: "modal-content" }
const _hoisted_8 = { class: "modal-header" }
const _hoisted_9 = {
  class: "modal-title fs-5 text-start",
  id: "awardModalLabel"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn-close",
  type: "button",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_11 = { class: "modal-body vh-75" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col text-start fs-6 fw-bold" }
const _hoisted_14 = { class: "row align-items-center" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "col-md-6 col-12 text-start fs-6 fw-bold lh-lg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "card overflow-hidden border-0 bg-grey",
      type: "button",
      "data-bs-toggle": "modal",
      "data-bs-target": '#awardModal-' + _ctx.id
    }, [
      _createElementVNode("img", {
        class: "card-img-top px-3 pt-3",
        src: _ctx.imgUrl
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.title), 1)
      ])
    ], 8, _hoisted_1),
    _createElementVNode("div", {
      class: "modal fade",
      id: 'awardModal-' +_ctx.id,
      tabindex: "-1",
      "aria-labelledby": "awardModalLabel",
      "aria-hidden": "true"
    }, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("h1", _hoisted_9, _toDisplayString(_ctx.title), 1),
            _hoisted_10
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.date), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("img", {
                class: "col-md-6 col-12 px-3 pt-3 img-fluid",
                src: _ctx.imgUrl
              }, null, 8, _hoisted_15),
              _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.content), 1)
            ])
          ])
        ])
      ])
    ], 8, _hoisted_5)
  ]))
}